import { useEffect, useState } from 'react'

export const DESKTOP_MEDIA_QUERY = '(min-width: 768px)'

function mediaQueryMatches(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) return false
  return window.matchMedia(DESKTOP_MEDIA_QUERY).matches
}

/**
 * D-053 splits the refresh affordance by layout, not by pointer type: below
 * 768 px the screen exposes pull-to-refresh, at 768 px and above it renders a
 * visible refresh button. Keep the listener so resizing the window swaps the
 * affordance without reloading the screen.
 */
export function useIsDesktop(): boolean {
  const [desktop, setDesktop] = useState(mediaQueryMatches)

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return
    const query = window.matchMedia(DESKTOP_MEDIA_QUERY)
    const update = () => setDesktop(query.matches)
    update()
    query.addEventListener?.('change', update)
    return () => query.removeEventListener?.('change', update)
  }, [])

  return desktop
}
